import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';

@Injectable({
  providedIn: 'root',
})
export class GiftCardsService {

  constructor(private firestore: AngularFirestore) { }

  async getGiftCards(businessId: string): Promise<any[]> {
    const db = getFirestore();
    const giftCardsRef = collection(db, 'GiftCards');
    const q = query(giftCardsRef, where('businessId', '==', businessId));

    const snapshot = await getDocs(q);

    const giftCards = snapshot.docs.map((doc) => ({
      ...doc.data(),
      formattedCreatedAt: this.formatDate(doc.data()['createdAt']),
      createdAt: doc.data()['createdAt']
    }));

    // Perform local sorting by createdAt (newest first)
    const sortedGiftCards = giftCards.sort((a, b) => {
      const dateA = a.createdAt.seconds || 0;
      const dateB = b.createdAt.seconds || 0;
      return dateB - dateA; // Sort by timestamp (newest first)
    });

    localStorage.setItem('giftCards', JSON.stringify(sortedGiftCards));
    return giftCards;
  }


  // Method to get cached gift cards from localStorage
  getCachedGiftCards(): any[] {
    const cachedCards = localStorage.getItem('giftCards');
    return cachedCards ? JSON.parse(cachedCards) : [];
  }

  // Method to clear localStorage (e.g., after deletion or update)
  clearCachedGiftCards(): void {
    localStorage.removeItem('giftCards');
  }

  // Utility function for date formatting
  private formatDate(date: any): string {
    const dateObj = new Date(date.seconds * 1000);
    return dateObj.toLocaleDateString('en-US');
  }

  // Update gift card status in Firebase
  updateGiftCardStatus(cardId: string, updateData: any): Promise<void> {
    return this.firestore.collection('GiftCards').doc(cardId).update(updateData);
  }

  // Delete a gift card
  deleteGiftCard(cardId: string): Promise<void> {
    return this.firestore.collection('GiftCards').doc(cardId).delete();
  }
}
